import styled, { useTheme } from 'styled-components';
import { ArrowIcon } from '../icons';
import { ReactNode } from 'react';

export enum ButtonTheme {
  DARK = 'DARK',
  LIGHT = 'LIGHT',
}

export interface DropdownButtonProps {
  isOpen: boolean;
  icon: ReactNode;
  onClick: () => void;
  className?: string;
  dataTest?: string;
  disabled?: boolean;
  colorTheme?: ButtonTheme;
}

export const DropdownButton: React.FC<DropdownButtonProps> = ({
  isOpen,
  icon,
  onClick,
  className,
  dataTest,
  disabled = false,
  colorTheme = ButtonTheme.LIGHT,
}) => {
  const theme = useTheme();
  return (
    <DropdownButtonStyle.DropdownButtonContainer
      data-testid={dataTest}
      onClick={onClick}
      open={isOpen}
      className={className}
      disabled={disabled}
      colorTheme={colorTheme}
    >
      <DropdownButtonStyle.IconContainer>{icon}</DropdownButtonStyle.IconContainer>
      <ArrowIcon
        className={className}
        direction={isOpen ? 'up' : 'down'}
        color={colorTheme === ButtonTheme.DARK || disabled ? theme.white : theme.secondary.softBlue1}
        disabled={disabled}
      />
    </DropdownButtonStyle.DropdownButtonContainer>
  );
};

export const DropdownButtonStyle = {
  DropdownButtonContainer: styled.div<{ open: boolean; disabled: boolean; colorTheme: ButtonTheme }>`
    opacity: ${({ disabled }) => (disabled ? 0.2 : 1)};
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background: ${({ theme, colorTheme, disabled }) =>
      colorTheme === ButtonTheme.DARK || disabled ? theme.secondary.softBlue2 : theme.secondary.chalk};
    border-radius: ${({ open }) => (open ? '4px 4px 0px 0px' : '4px')};
    padding: 8px 12px 8px 16px;
    height: 16px;
    width: 32px;

    ${({ disabled }) => {
      if (!disabled) {
        return '&:hover { filter: drop-shadow(0px 2px 6px rgba(0, 70, 107, 0.25)); cursor: pointer; }';
      }
    }}
  `,
  IconContainer: styled.div`
    margin-right: 5px;
  `,
};
